<template>
  <div class="overflow-x-auto bg-grey-lighter rounded-xl mb-5">
    <table class="min-w-full">
      <thead>
        <tr class="bg-grey-lighter">
          <!-- Skeleton loader for headers -->
          <th v-for="n in this.columns" :key="n" class="py-5 px-10 font-semibold text-grey-darker text-3xl uppercase fixed-column">
            <div class="ml-8 h-6 w-3/4 bg-grey rounded-xl skeleton"></div>
          </th>
        </tr>
      </thead>
      <tbody>
        <!-- Skeleton rows for table -->
        <tr v-for="n in this.rows" :key="n" :class="n % 2 === 0 ? 'bg-grey-lighter' : 'bg-white'" style="height: 80px;">
          <td v-for="i in this.columns" :key="i" class="py-5 px-10 text-center text-2xl">
            <div class="ml-8 h-6 w-3/4 bg-grey-light rounded-xl skeleton"></div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import mixin from '@/mixins/controls.js';

export default {
  name: 'v-table-skeleton',
  mixins: [mixin],
  props: {
    rows: {
      type: Number,
      default: 5,
    },
    columns: {
      type: Number,
      default: 4,
    },
  }
}
</script>

<style scoped>
.fixed-column {
  width: 250px;
  /* Adjusted for 4 columns */
}

.skeleton {
  animation: pulse-opacity 1.5s infinite;
}

@keyframes pulse-opacity {

  0%,
  100% {
    opacity: 1;
  }

  50% {
    opacity: 0.6;
  }
}
</style>
